import { Chip, Tooltip } from '@xbotvn/mui';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { APPROVAL_OPTIONS } from '../libs/utils';

const approvalLabelMap = _.keyBy(APPROVAL_OPTIONS, 'value');

const ApprovalStatusChip = ({ status, note }) => {
  const label = approvalLabelMap?.[status]?.label || 'Chưa gửi';

  let chipColor = 'default';
  if (status === 'approved') {
    chipColor = 'success';
  } else if (status === 'pending') {
    chipColor = 'warning';
  } else if (status === 'rejected') {
    chipColor = 'error';
  }

  const chip = (
    <Chip
      color={chipColor}
      label={label}
      size="small"
    />
  );

  if (status === 'rejected' && note) {
    return (
      <Tooltip title={note} placement="top">
        <div style={{ display: 'inline-block' }}>{chip}</div>
      </Tooltip>
    );
  }

  return chip;
};

ApprovalStatusChip.propTypes = {
  status: PropTypes.string,
  note: PropTypes.string,
};

ApprovalStatusChip.defaultProps = {
  status: undefined,
  note: undefined,
};

export default ApprovalStatusChip;
